<template src="./CustomersWithoutFirstAccess.html"></template>
<script>
import moment from "moment";
import mixins from "../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      customers: [],
      selected: [],
      searchCustomers: "",
      popupAlertCustomerSms: false,
      titlePopupAlertCustomerSms: "",
      textPopupAlertCustomerSms: "",
      customerSelected: null,
      csvHistoric: {},
      historicCsv: [],
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
    };
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    customers: function (newVal) {
      const vm = this;
      vm.customers = newVal;
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getCustomers();
    },
    changeSearchCustomers() {
      const vm = this;
      setTimeout(() => {
        vm.getCustomers();
      }, 2000);
    },
    getCustomers() {
      const vm = this;
      vm.$vs.loading();
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "consultant/listPatientsPendingFinishSubscribe?page=" +
            page +
            "&search=" +
            vm.searchCustomers +
            "&size=10"
            ,
          {
            headers: {
              Authorization: vm.$session.get("bearer"),
            },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.customers = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.$vs.loading.close();
          }
        })
        .catch(function () {
          vm.$vs.loading.close();
        });
    },
    handleSearch(searching) {
      const vm = this;
      vm.searchCustomers = searching;
      vm.getCustomers();
    },
    changePagination() {
      const vm = this;
      vm.getCustomers();
    },
    formatDate(date) {
      const vm = this;
      if (vm.testNullUndefinedEmpty(date)) {
        return "Sem registro";
      } else {
        let dateFormat = moment(date).format("DD/MM/YYYY hh:mm:ss");
        return dateFormat;
      }
    },
    openPopupAlertCustomer(customer) {
      const vm = this;
      vm.customerSelected = customer;
      vm.titlePopupAlertCustomerSms =
        "Reenvio de sms de boas vindas para o cliente : " + customer.name;
      vm.textPopupAlertCustomerSms =
        "Você realmente deseja reenviar o sms de boas vindas para o cliente " +
        customer.name +
        "?";
      vm.popupAlertCustomerSms = true;
    },
    openPopupAlertCustomers() {
      const vm = this;
      vm.customerSelected = null;
      vm.titlePopupAlertCustomerSms = "Reenvio de sms de boas vindas";
      vm.textPopupAlertCustomerSms =
        "Você realmente deseja reenviar o sms de boas vindas para todos os clientes que não realizaram o primeiro acesso ao sistema?";
      vm.popupAlertCustomerSms = true;
    },
    resendAllCustumersSms() {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .post(
          vm.$store.state.filooServer +
            "consultant/sendSmsPatientsPendingFinishSubscribe")
        .then(function (response) {
          if (response.status === 200) {
            vm.popupAlertCustomerSms = false;
            vm.$swal({
              title: "Sucesso!",
              text:
                "Operação realizada com sucesso! O sms de boas vindas foi enviado para os clientes.",
              icon: "success",
            }).then(function () {
              vm.getCustomers();
            });
          }
        })
        .catch(function () {
          vm.popupAlertCustomerSms = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível executar esta operação.Por favor, entre em contato com o administrador do sistema. ",
            icon: "error",
          });
        });
    },
    resendCustumerSms() {
      this.axios.defaults.headers.common["Authorization"] = this.$session.get(
        "bearer"
      );
      this.axios
        .post(
          `${this.$store.state.filooServer}consultant/sendSmsPatientPendingFinishSubscribe?patientId=${this.customerSelected.id}`,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        .then(response => {          
          if (response.status === 200) {
          this.popupAlertCustomerSms = false;     
          this.$swal({
              title: "Sucesso!",
              text:
                "Operação realizada com sucesso! O sms de boas vindas foi enviado para o cliente " + this.customerSelected.name + ".",
              icon: "success",
            }).then(() => {
              this.customerSelected = null;
              this.getCustomers();
            });
          }
        })
        .catch(() =>{
          this.popupAlertCustomerSms = false;
          this.$swal({
            title: "Atenção!",
            text:
              "Não foi possível executar esta operação.Por favor, entre em contato com o administrador do sistema. ",
            icon: "error",
          });
        });
    },
    fillCards() {
      const vm = this;
      vm.$vs.loading.close();
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" src="./CustomersWithoutFirstAccess.scss">
</style>
